import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconClobeFill = ({ width = 24, height = 24, fill = '#1D2225', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.976 2.5c5.26 0 9.524 4.253 9.524 9.5s-4.264 9.5-9.524 9.5a9.79 9.79 0 0 1-.928-.046l7.67-6.42c.504-.42.569-1.169.146-1.67a1.192 1.192 0 0 0-1.675-.147l-8.975 7.511a9.49 9.49 0 0 1-1.275-.666l3.043-2.545c.503-.422.569-1.17.146-1.671A1.193 1.193 0 0 0 8.45 15.7l-3.386 2.834a9.556 9.556 0 0 1-.841-1.017l7.583-6.347c.502-.421.568-1.17.145-1.671a1.193 1.193 0 0 0-1.677-.145l-7.2 6.027a9.406 9.406 0 0 1-.412-1.385l4.134-3.459c.503-.421.568-1.17.145-1.67a1.193 1.193 0 0 0-1.676-.147L2.5 11.035C2.985 6.242 7.042 2.5 11.976 2.5Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconClobeFill;
